import React, { useState } from 'react';
import { gql, useQuery } from '@apollo/client';
import { handleError } from '@domain-group/fe-helper';
import { GetContactSalesStatisticsDataQuery } from '../../../generated/graphql';
import { IActiveSuburb, ISuburbStatistics } from '../@types';
import SalesStatistics, { ALL_SUBURBS_SUBURB_SLUG } from './sales-statistics';
import { SUBURB_STATISTICS_FRAGMENT } from '../shared';

export const GET_CONTACT_SALES_STATISTICS_DATA_QUERY = gql`
  query getContactSalesStatisticsData(
    $agencyId: Int!
    $agentIdV2: String!
    $suburbSlug: String
  ) {
    contactByAgencyIdAndAgentId(agencyId: $agencyId, agentIdV2: $agentIdV2) {
      id
      suburbStatisticsData: suburbStatistics(suburbSlug: $suburbSlug) {
        ...SuburbStatistics
      }
    }
  }
  ${SUBURB_STATISTICS_FRAGMENT}
`;

export type Props = {
  agencyId: number;
  agentIdV2: string;
  tracking?: {
    onSuburbChange?: (suburbName: string) => void;
  };
  activeSuburbs: IActiveSuburb[];
  allSuburbStatistics: ISuburbStatistics;
};

const ContactSalesStatistics = ({
  agencyId,
  agentIdV2,
  tracking,
  activeSuburbs,
  allSuburbStatistics,
}: Props): React.ReactElement | null => {
  const [suburbSlug, setSuburbSlug] = useState<string>(ALL_SUBURBS_SUBURB_SLUG);

  const { data, error, loading } = useQuery<GetContactSalesStatisticsDataQuery>(
    GET_CONTACT_SALES_STATISTICS_DATA_QUERY,
    {
      skip: suburbSlug === ALL_SUBURBS_SUBURB_SLUG,
      variables: {
        agencyId,
        agentIdV2,
        suburbSlug,
      },
    },
  );

  if (error) {
    handleError(error);
  }

  return (
    <SalesStatistics
      tracking={tracking}
      activeSuburbs={activeSuburbs}
      selectedSuburb={suburbSlug}
      setSelectedSuburb={setSuburbSlug}
      allSuburbStatistics={allSuburbStatistics}
      loading={loading}
      suburbStatisticsData={
        data?.contactByAgencyIdAndAgentId?.suburbStatisticsData
      }
    />
  );
};

export default ContactSalesStatistics;
